import { configureStore } from '@reduxjs/toolkit';
import goalReducer from './slices/goalSlice.js';
import insightsReducer from './slices/recommendationSlice.js';
import dashboardReducer from './slices/dashboardSlice.js';
import reportReducer from './slices/reportSlice.js';

export const store = configureStore({
  reducer: {
    goals: goalReducer,
    insights: insightsReducer,
    dashboard: dashboardReducer,
    reports: reportReducer,
    // Add other reducers here as needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Allow certain action types to have non-serializable values
        ignoredActions: [
          'goals/fetchGoals/rejected',
          'goals/createGoal/rejected',
          'goals/updateGoalProgress/rejected',
          'goals/deleteGoal/rejected',
          'insights/fetchInsights/rejected',
          'dashboard/fetchDashboard/rejected',
          'reports/fetchReportIdByType/rejected',
          'reports/fetchAllReportIds/rejected',
        ],
      },
    }),
  devTools: import.meta.env.MODE !== 'production',
});

export default store;
